(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milanis-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('milanis-newsletter-popup')) customElements.define('milanis-newsletter-popup', class extends HTMLElement {
  connectedCallback() { this.initTimer = setTimeout(() => this.init(), 0); }
  init() {
    if (!this.isConnected || this.controller) return;
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.controller = new AbortController();
    const options = {signal: this.controller.signal};
    const editor = this.dataset.editor === 'true';
    const form = this.querySelector('form');
    const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
    const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
    const remove = (storage, key) => { try { window[storage].removeItem(key); } catch {} };
    const key = 'milanis-newsletter-dismissed-v1';
    const pendingKey = 'milanis-newsletter-pending';
    const successKey = 'milanis-newsletter-subscribed-v1';
    const pending = read('sessionStorage', pendingKey) === form?.id;
    const result = pending && !!this.querySelector('[data-success], [data-error]');
    const success = result && !!this.querySelector('[data-success]');
    if (success) { write('localStorage', successKey, 'true'); remove('sessionStorage', pendingKey); }
    this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const r = this.dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
    }, options);
    this.dialog.addEventListener('close', () => {
      this.unlock();
      if (!editor) { write('localStorage', key, String(Date.now())); write('sessionStorage', key, 'true'); }
      if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll:true});
    }, options);
    form?.addEventListener('submit', () => write('sessionStorage', pendingKey, form.id), options);
    this.querySelector('[data-preview]')?.addEventListener('click', () => this.open(), options);
    document.addEventListener('shopify:section:select', event => { if (editor && event.detail.sectionId === this.dataset.section) this.open(); }, options);
    document.addEventListener('shopify:section:deselect', event => { if (editor && event.detail.sectionId === this.dataset.section) this.dialog.close(); }, options);
    if (editor) return;
    if (!result && (this.dataset.enabled !== 'true' || this.dataset.subscribed === 'true' || read('localStorage', successKey))) return;
    const days = Number(this.dataset.repeat) || 0;
    const dismissed = Number(read('localStorage', key)) || 0;
    if (!result && (read('sessionStorage', key) || (days > 0 && Date.now() - dismissed < days * 86400000))) return;
    const attempt = () => {
      if (!this.isConnected) return;
      const anotherModalIsVisible = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(modal => {
        if (modal === this.dialog || modal.closest('[hidden], [aria-hidden="true"], details:not([open])')) return false;
        if (modal.checkVisibility && !modal.checkVisibility({checkOpacity:true, checkVisibilityCSS:true})) return false;
        const rect = modal.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < innerWidth && rect.top < innerHeight;
      });
      // Wait while a customer is using another modal, menu or form.
      if (document.hidden || anotherModalIsVisible || document.activeElement?.matches('input, textarea, select') || getComputedStyle(document.body).overflowY === 'hidden' || getComputedStyle(document.documentElement).overflowY === 'hidden') {
        this.showTimer = setTimeout(attempt, 1000); return;
      }
      this.open();
    };
    this.showTimer = setTimeout(attempt, result ? 0 : Math.max(0, Number(this.dataset.delay) || 5000));
  }
  open() {
    if (!this.dialog || this.dialog.open) return;
    this.previousFocus = document.activeElement;
    this.oldOverflow = document.documentElement.style.overflow;
    this.dialog.showModal();
    this.locked = true;
    document.documentElement.style.overflow = 'hidden';
    this.dialog.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
    this.dialog.querySelector('.mvn-close').focus({preventScroll:true});
  }
  unlock() { if (this.locked) { document.documentElement.style.overflow = this.oldOverflow || ''; this.locked = false; } }
  disconnectedCallback() {
    clearTimeout(this.initTimer); clearTimeout(this.showTimer);
    this.controller?.abort(); this.controller = null;
    this.dialog?.close(); this.unlock();
  }
});

  } catch(e) { console.error(e); }
})();
})();
